import {ActionTree} from 'vuex'
import {AxiosError, AxiosResponse} from "axios";
import moment from 'moment';
// @ts-ignore
import Api from "@/api";

export const actions: ActionTree<any, any> = {

    getWidgetsConfig: ({state, getters, commit, dispatch}, widget: any) => {

        return new Promise((resolve, reject) => {

            Api.get('/dashboard/widgets')

                .then(({data}: AxiosResponse) => {
                    commit('setWidgetsConfig', data.widgets);
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    reject(error.response);
                });
        });
    },

    updateWidget: ({state, getters, commit, dispatch}, widget: any) => {

        commit('updateWidget', widget);

        return new Promise((resolve, reject) => {

            Api.put('/dashboard/widget', widget)

                .then(() => {
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    reject(error.response);
                });
        });
    },

    updateWidgetsOrder: ({state, getters, commit, dispatch}, data: Array<number>) => {

        return new Promise((resolve, reject) => {

            Api.post('/dashboard/widgets/order', {data: data})

                .then(() => {
                    resolve(null);
                })
                .catch((error: AxiosError) => {
                    reject(error.response);
                });
        });
    },

    getPanelSizeStats: ({state, getters, commit, dispatch}, force: boolean) => {

        if (force) state.panelSizeStatsExpire = null;

        return new Promise((resolve, reject) => {

            if (state.panelSizeStatsExpire && moment().isBefore(state.panelSizeStatsExpire)) {
                resolve(null);
            } else {
                Api.get('/dashboard/panel/growth?limit=12')

                    .then(({data}: AxiosResponse) => {

                        commit('setPanelSizeStats', data.items);
                        resolve(null);
                    })
                    .catch((error: AxiosError) => {

                        reject(error);
                    });
            }
        });
    },

    getProjectActivityStatsDaily: ({state, getters, commit, dispatch}, force: boolean) => {

        if (force) state.projectActivityStatsExpire = null;

        return new Promise((resolve, reject) => {

            if (state.projectActivityStatsExpire && moment().isBefore(state.projectActivityStatsExpire)) {
                resolve(null);
            } else {
                Api.get('/dashboard/stats/activity?type=daily&limit=14')

                    .then(({data}: AxiosResponse) => {
                        commit('setProjectActivityStats', data.items);
                        resolve(null);
                    })
                    .catch((error: AxiosError) => {

                        reject(error);
                    });
            }
        });
    },

    getProjectActivityStatsForLastHour: ({state, getters, commit, dispatch}, force) => {

        if (force) state.projectActivityStatsHourExpires = null;

        return new Promise((resolve, reject) => {

            if (state.projectActivityStatsHourExpires && moment().isBefore(state.projectActivityStatsHourExpires)) {
                resolve(state.projectActivityStatsHour);
            } else {
                Api.get('/dashboard/projects/stats/activity')

                    .then((response: AxiosResponse) => {

                        commit('setProjectActivityStatsForLastHour', response.data.project);
                        resolve(response.data);
                    })
                    .catch((error: AxiosError) => {

                        reject(error);
                    });
            }
        });
    },

    getStatusPredictions: ({state, getters, commit, dispatch}, {force, type}) => {

        if (force) state.statusPredictionsExpire = null;

        return new Promise((resolve, reject) => {

            if (state.statusPredictionsExpire && moment().isBefore(state.statusPredictionsExpire)) {
                resolve(state.statusPredictions);
            } else {
                Api.get('/dashboard/panel/statuses/predict?type=' + type)

                    .then((response: AxiosResponse) => {

                        commit('setStatusPredictions', {
                            current: response.data.current,
                        });

                        resolve(response.data);
                    })
                    .catch((error: AxiosError) => {

                        reject(error);
                    });
            }
        });
    },

    getChurnStats: ({state, getters, commit, dispatch}, {force, months, subPanelFilterIds}) => {

        return new Promise((resolve, reject) => {

            let url = '/dashboard/stats/churn';

            let params = [];

            if (months) {
                params.push('months=' + months);
            }

            if (subPanelFilterIds && subPanelFilterIds.length > 0) {
                params.push('sub_panels=' + subPanelFilterIds.join(','));
            }

            if (params.length > 0) {
                url += '?' + params.join('&')
            }

            Api.get(url)
                .then(({data}: AxiosResponse) => {
                    commit('setChurnChart', {data: data});
                    resolve(data.data);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    getTopProjects: ({state, getters, commit, dispatch}, {force, subPanelFilterIds, filter}) => {

        return new Promise((resolve, reject) => {

            let url = '/dashboard/top-projects';

            let params = [];

            if (subPanelFilterIds && subPanelFilterIds.length > 0) {
                params.push('sub_panels=' + subPanelFilterIds.join(','));
            }

            if (filter.length > 0) {
                params.push('filter=' + filter);
            }

            if (force) {
                params.push('force=true');
            }

            if (params.length > 0) {
                url += '?' + params.join('&')
            }

            Api.get(url)
                .then(({data}: AxiosResponse) => {
                    commit('setTopProjects', {data: data});
                    resolve(data.data);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    getBusinessRulesImpact: ({state, getters, commit, dispatch}, {force, subPanelFilterIds, filter}) => {

        if (force) state.businessRulesImpactExpires = null;

        // Pull from store if loaded and cache hasn't expired
        if (state.businessRulesImpactExpires && moment().isBefore(state.businessRulesImpactExpires)) {
            return state.businessRulesImpact;
        }

        commit('setBusinessRulesImpactLoading', true);

        return new Promise((resolve, reject) => {

            let url = '/dashboard/business-rules-impact';

            let params = [];

            if (subPanelFilterIds.length > 0) {
                params.push('sub_panels=' + subPanelFilterIds.join(','));
            }

            if (filter.length > 0) {
                params.push('filter=' + filter);
            }

            if (force) {
                params.push('force=1');
            }

            if (params.length > 0) {
                url = url + '?' + params.join('&');
            }

            Api.get(url)

                .then(({data}: AxiosResponse) => {
                    commit('setBusinessRulesImpact', data.data);
                    commit('setBusinessRulesImpactLoading', false);
                    resolve(data);
                })
                .catch((error: AxiosError) => {
                    commit('setBusinessRulesImpactLoading', false);
                    reject(error);
                });
        });
    },
};
